// reactstrap components
import { Container, Row } from "reactstrap";
// core components
import Header from "../../../components/Headers/Header.js";

const SurveyDetails = () => {
  return (
    <>
      <Header />
      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <h1>User's Survey Details</h1>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default SurveyDetails;
